import ComarcaList from './list';

// ***************************************************
// COMARCA PASSA A SER MUNICIPIO
//
export default function ComarcaPage() {
  return <ComarcaList />;
}
